import { render, staticRenderFns } from "./ProjectTradeOff.vue?vue&type=template&id=55ba5c93&scoped=true"
import script from "./ProjectTradeOff.vue?vue&type=script&lang=js"
export * from "./ProjectTradeOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ba5c93",
  null
  
)

export default component.exports